const $condition = Symbol('condition');
export function isConditionalObject(value) {
    return typeof value === 'object' && !!value && $condition in value;
}
export function markConditionalObject(value) {
    value[$condition] = true;
    return value;
}
export function assignConditionalProperty(target, property, value, condition, isConditional = isConditionalObject) {
    if (condition) {
        // The source value is a condition query; merge it with the target value.
        const targetValue = target[property];
        if (isConditional(targetValue)) {
            // Preserve key order
            delete targetValue[condition];
            // nosemgrep: prototype-pollution-assignment
            targetValue[condition] = value;
        } else if (targetValue == null) {
            target[property] = {
                [condition]: value
            };
            markConditionalObject(target[property]);
        } else {
            target[property] = {
                default: targetValue,
                [condition]: value
            };
            markConditionalObject(target[property]);
        }
    } else {
        // The source value is a string or undefined; overwrite the target value.
        target[property] = value;
    }
}
function assignWithKeyOrder(target, source) {
    const keys = Object.keys(source);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key in target) {
            delete target[key];
        }
        target[key] = source[key];
    }
}
export function mergeConditionalProperty(target, property, value, isConditional = isConditionalObject) {
    if (isConditional(value)) {
        // The source value is an object; merge it with the target value.
        const targetValue = target[property];
        if (isConditional(targetValue)) {
            assignWithKeyOrder(targetValue, value);
        } else {
            target[property] = targetValue == null ? {} : {
                default: targetValue
            };
            Object.assign(target[property], value);
        }
    } else {
        // The source value is a string or undefined; overwrite the target value.
        target[property] = value;
    }
}

//# sourceMappingURL=ConditionalObject.js.map